"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAutocomplete = useAutocomplete;

var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));

var _react = require("react");

var _usehooksTs = require("usehooks-ts");

var _constants = require("../constants");

var _apiContext = require("../../../context/apiContext");

var _fetchData2 = require("../utils/fetchData");

var _customTakeLatest = require("../utils/customTakeLatest");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function useAutocomplete() {
  var searchType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.SEARCH_TYPE_NAMES.PACKAGE;
  var isWizard = arguments.length > 1 ? arguments[1] : undefined;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      startOptions = _useState2[0],
      setStartOptions = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      fullOptions = _useState4[0],
      setFullOptions = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      foundGroupedOptions = _useState6[0],
      setFoundGroupedOptions = _useState6[1];

  var _useState7 = (0, _react.useState)(),
      _useState8 = _slicedToArray(_useState7, 2),
      params = _useState8[0],
      setParams = _useState8[1];

  var _useState9 = (0, _react.useState)(),
      _useState10 = _slicedToArray(_useState9, 2),
      departureValue = _useState10[0],
      setDepartureValue = _useState10[1];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      loading = _useState12[0],
      setLoading = _useState12[1];

  var isMounted = (0, _usehooksTs.useIsMounted)();
  var debounceDepartureValue = (0, _usehooksTs.useDebounce)(departureValue, 100);
  var hasFromCityParam = searchType === _constants.SEARCH_TYPE_NAMES.PACKAGE && !isWizard;

  var _useState13 = (0, _react.useState)(),
      _useState14 = _slicedToArray(_useState13, 2),
      allCountriesLookup = _useState14[0],
      setAllCountriesLookup = _useState14[1];

  var api = (0, _apiContext.useGetApiClient)();
  /**
   * Приводим данные страны Трипстера в формат страны ЛТ
   */

  var formatTripsterCountry = function formatTripsterCountry(country) {
    return {
      value: country.id,
      label: country.title.replaceAll(/<\/?em>/gm, ''),
      visa: '',
      closed: false,
      budget: 0,
      nameEn: '',
      nameRuForm3: '',
      url: country.url,
      isTrip: true
    };
  };
  /**
   * Приводим данные метарегиона Трипстера в формат метарегиона ЛТ
   */


  var formatTripsterMetaregion = function formatTripsterMetaregion(metaregion) {
    var _metaregion$country, _metaregion$country$n;

    return {
      value: metaregion.id,
      label: metaregion.title.replaceAll(/<\/?em>/gm, ''),
      description: (_metaregion$country = metaregion.country) === null || _metaregion$country === void 0 ? void 0 : (_metaregion$country$n = _metaregion$country.name_ru) === null || _metaregion$country$n === void 0 ? void 0 : _metaregion$country$n.replaceAll(/<\/?em>/gm, ''),
      url: metaregion.url,
      isTrip: true
    };
  };
  /**
   * Заполняем массив опций стран:
   * в начальные опций записываем первые 5,
   * в полные - все по аналогии с тем, что возвращает referencesPlaces
   */


  var fillTripsterCountriesOptions = function fillTripsterCountriesOptions(tripsterStartOptions, tripsterFullOptions, countries) {
    tripsterStartOptions[0].fullOptionsCount = countries.length;
    countries.forEach(function (country, i) {
      var formattedTripsterCountry = formatTripsterCountry(country);

      if (i < 5) {
        tripsterStartOptions[0].options.push(_objectSpread(_objectSpread({}, formattedTripsterCountry), {}, {
          groupName: 'popularCountries'
        }));
      }

      tripsterFullOptions[0].options.push(_objectSpread(_objectSpread({}, formattedTripsterCountry), {}, {
        groupName: 'allCountries'
      }));
    });
  };
  /**
   * Заполняем массив опций метарегионов:
   * в начальные опций записываем первые 3,
   * в полные - все  по аналогии с тем, что возвращает referencesPlaces
   */


  var fillTripsterMetaregionsOptions = function fillTripsterMetaregionsOptions(tripsterStartOptions, tripsterFullOptions, metaregions) {
    tripsterStartOptions[1].fullOptionsCount = metaregions.length;
    metaregions.forEach(function (metaregion, i) {
      var formattedTripsterMetaregion = formatTripsterMetaregion(metaregion);

      if (i < 3) {
        tripsterStartOptions[1].options.push(_objectSpread(_objectSpread({}, formattedTripsterMetaregion), {}, {
          groupName: 'metaregions'
        }));
      }

      tripsterFullOptions[1].options.push(_objectSpread(_objectSpread({}, formattedTripsterMetaregion), {}, {
        groupName: 'allMetaregions'
      }));
    });
  };
  /**
   * Получаем направления Трипстера для поиска экскурсий
   * Страны и города с регионами запрашиваем отдельно, т.к.
   * без указания типа возвращаются только города
   */


  var getTripsterPlaces = function getTripsterPlaces() {
    return Promise.all([fetch("".concat(_constants.TRIPSTER_API_PATH, "?types=country")), fetch("".concat(_constants.TRIPSTER_API_PATH, "?types=city,region"))]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          countriesResponse = _ref2[0],
          metaregionsResponse = _ref2[1];

      return Promise.all([countriesResponse.json(), metaregionsResponse.json()]);
    }).then(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          countries = _ref4[0],
          metaregions = _ref4[1];

      var tripsterStartOptions = (0, _cloneDeep2["default"])(_constants.DEFAULT_TRIPSTER_START_OPTIONS);
      var tripsterFullOptions = (0, _cloneDeep2["default"])(_constants.DEFAULT_TRIPSTER_FULL_OPTIONS);
      fillTripsterCountriesOptions(tripsterStartOptions, tripsterFullOptions, countries);
      fillTripsterMetaregionsOptions(tripsterStartOptions, tripsterFullOptions, metaregions);
      setStartOptions(tripsterStartOptions);
      setFullOptions(tripsterFullOptions);
    })["finally"](function () {
      setLoading(false);
    });
  }; // Получаем направления ЛТ для поиска туров или отелей


  var getReferencesPlaces = function getReferencesPlaces(placesParams) {
    if (!isMounted()) return;
    if (api) (0, _customTakeLatest.customTakeLatest)(api.referencesPlaces(placesParams)) // @todo
    .then(function (data) {
      var popularDirections = (data === null || data === void 0 ? void 0 : data.popularDirections) && (data === null || data === void 0 ? void 0 : data.popularDirections[0].options) || []; // Мэтчим данные направления и страны

      if (allCountriesLookup) {
        popularDirections === null || popularDirections === void 0 ? void 0 : popularDirections.forEach(function (direction, idx) {
          var country = allCountriesLookup[direction.countryId];
          popularDirections[idx] = _objectSpread(_objectSpread({}, direction), {}, {
            country: country
          });
        });
      }

      setStartOptions(allCountriesLookup && data.popularDirections ? [].concat(_toConsumableArray(data.startOptions), [data.popularDirections[0]]) : data.startOptions);
      setFullOptions(allCountriesLookup && data.popularDirections ? [].concat(_toConsumableArray(data.fullOptions), [data.popularDirections[0]]) : data.fullOptions);

      if (!popularDirections.length || allCountriesLookup) {
        setLoading(false);
      }
    })["catch"](function (error) {
      console.error(error);
    });
  };
  /**
   * Формируем урл для запроса автокомплита Трипстера,
   * когда пользователь ввёл что-то в поле направлений
   */


  var getTripsterQueryUrl = function getTripsterQueryUrl(queryWithoutQuotes) {
    var queryParams = new URLSearchParams({
      query: queryWithoutQuotes,
      limit: '10',
      types: 'city, region, country'
    });
    return "".concat(_constants.TRIPSTER_API_PATH, "?").concat(queryParams.toString());
  };
  /**
   * Дёргаем автокомплит Трипстера, когда пользователь ввёл что-то
   * в поле выбора направления при поиске экскурсий
   */


  var getTripsterAutocomplete = function getTripsterAutocomplete(queryWithoutQuotes) {
    var apiUrl = getTripsterQueryUrl(queryWithoutQuotes);
    fetch(apiUrl).then(function (response) {
      return response.json();
    }).then(function (options) {
      if (!isMounted()) return;
      var queryWithEm = "<em>".concat(queryWithoutQuotes, "</em>");
      var isPerfectMatch = options[0] === queryWithEm;
      var preparedData = (0, _cloneDeep2["default"])(_constants.DEFAULT_TRIPSTER_START_OPTIONS);
      options.forEach(function (option) {
        if (option.type === 'country') {
          preparedData[0].options.push(_objectSpread(_objectSpread({}, formatTripsterCountry(option)), {}, {
            groupName: 'popularCountries'
          }));
        } else if (!isPerfectMatch || isPerfectMatch && option.country.name_ru === queryWithEm) {
          preparedData[1].options.push(_objectSpread(_objectSpread({}, formatTripsterMetaregion(option)), {}, {
            groupName: 'metaregions'
          }));
        }
      });
      setFoundGroupedOptions(preparedData);
    })["finally"](function () {
      setLoading(false);
    });
  };
  /**
   * Дёргаем автокомплит ЛТ, когда пользователь ввёл что-то
   * в поле выбора направления при поиске туров / отелей
   */


  var getLtAutocomplete = function getLtAutocomplete(queryWithoutQuotes) {
    var _fetchData;

    if (!params) return;
    var autocompleteParams = searchType === _constants.SEARCH_TYPE_NAMES.PACKAGE ? {
      query: queryWithoutQuotes,
      from_city: params.from_city,
      search_type: searchType
    } : {
      query: queryWithoutQuotes,
      search_type: searchType
    };
    (_fetchData = (0, _fetchData2.fetchData)(api === null || api === void 0 ? void 0 : api.referencesAutocompleteV2(autocompleteParams), autocompleteParams.query)) === null || _fetchData === void 0 ? void 0 : _fetchData.then(function (options) {
      if (isMounted()) {
        setFoundGroupedOptions(options);
      }
    })["catch"](console.error)["finally"](function () {
      setLoading(false);
    });
  };

  (0, _react.useEffect)(function () {
    api === null || api === void 0 ? void 0 : api.getReferencesCountries({}).then(function (data) {
      if (!data) return;
      var allCountriesLookup = data.reduce(function (countriesLookup, country) {
        return _objectSpread(_objectSpread({}, countriesLookup), {}, _defineProperty({}, country.id, country));
      }, {});
      setAllCountriesLookup(allCountriesLookup);
    });
  }, [api]);
  (0, _react.useEffect)(function () {
    try {
      setLoading(true);

      if (searchType === _constants.SEARCH_TYPE_NAMES.TRIP) {
        if (!isMounted()) return;
        getTripsterPlaces();
      } else {
        var placesParams = {
          search_type: searchType,
          from_city: hasFromCityParam ? debounceDepartureValue : undefined
        };
        getReferencesPlaces(placesParams);
      }
    } catch (err) {
      console.error(err);
    }
  }, [isMounted, debounceDepartureValue, searchType, allCountriesLookup]);
  (0, _react.useEffect)(function () {
    var _params$query;

    var queryWithoutQuotes = params === null || params === void 0 ? void 0 : (_params$query = params.query) === null || _params$query === void 0 ? void 0 : _params$query.replace(/['"]/g, '');

    if (params && queryWithoutQuotes) {
      setLoading(true);

      if (searchType === _constants.SEARCH_TYPE_NAMES.TRIP) {
        getTripsterAutocomplete(queryWithoutQuotes);
        return;
      }

      getLtAutocomplete(queryWithoutQuotes);
    }
  }, [isMounted, params, searchType]);
  return {
    startOptions: startOptions,
    fullOptions: fullOptions,
    foundGroupedOptions: foundGroupedOptions,
    setParams: setParams,
    loading: loading,
    setDepartureValue: setDepartureValue
  };
}